// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1poSj","checkboxCol":"Table_checkboxCol__jzANI","emailCol":"Table_emailCol__2reJW","actionCol":"Table_actionCol__1PG_e"};